<template>
    <div>
        <div class="container py-4">
            <h2 class="mb-4">Instellingen</h2>
            <div class="card">
                <div class="card-body">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a aria-controls="pills-home" aria-selected="true" class="nav-link active"
                               data-toggle="pill"
                               href="#kleuren" id="pills-home-tab" role="tab">Kleuren</a>
                        </li>
                        <li class="nav-item">
                            <a aria-controls="pills-profile" aria-selected="false" class="nav-link" data-toggle="pill"
                               href="#logo" id="pills-profile-tab" role="tab">Logo</a>
                        </li>
                        <li class="nav-item">
                            <a aria-controls="pills-contact" aria-selected="false" class="nav-link" data-toggle="pill"
                               href="#podio" id="pills-contact-tab" role="tab">Instellingen Podio</a>
                        </li>
                    </ul>
                    <hr>
                    <div class="tab-content" id="myTabContent">
                        <div aria-labelledby="home-tab" class="tab-pane fade show active" id="kleuren" role="tabpanel">
                            <div class="mt-3 ml-3">
                                <p>Verander de kleuren van de applicatie via deze instelling.</p>
                                <ul>
                                    <li>Achtergrond: achtergrondkleur van de volledige applicatie</li>
                                    <li>Hoofdkleur: kleur van de check-knoppen aan de linkerkant</li>
                                    <li>Accentkleur: kleur van de filter-knop aan de linkerkant</li>
                                </ul>
                            </div>

                            <div class="row mt-4">
                                <div class="col-md-4">
                                    <custom-color-picker :attribute="this.background.attribute"
                                                         :color="this.settings[this.background.attribute]"
                                                         :title="this.background.title"
                                                         @changeValue="changeValue"></custom-color-picker>
                                </div>
                                <div class="col-md-4">
                                    <custom-color-picker :attribute="this.primary.attribute"
                                                         :color="this.settings[this.primary.attribute]"
                                                         :title="this.primary.title"
                                                         @changeValue="changeValue"></custom-color-picker>
                                </div>
                                <div class="col-md-4">
                                    <custom-color-picker :attribute="this.secondary.attribute"
                                                         :color="this.settings[this.secondary.attribute]"
                                                         :title="this.secondary.title"
                                                         @changeValue="changeValue"></custom-color-picker>
                                </div>
                            </div>
                        </div>
                        <div aria-labelledby="profile-tab" class="tab-pane fade" id="logo" role="tabpanel">
                            <div class="mt-3 ml-3">
                                <p>Kies het logo van de applicatie, dit logo staat in de linkerbovenhoek.</p>
                            </div>
                            <div class="row mt-4">
                                <div class="col-md-6 ml-3">
                                    <div class="form-group">
                                        <input id="file" ref="file" type="file" v-on:change="handleFileUpload()" />
                                    </div>
                                    <button @click="submit" class="btn btn-primary btn-sm" type="button">Opslaan</button>
                                </div>
                            </div>
                        </div>
                        <div aria-labelledby="contact-tab" class="tab-pane fade" id="podio" role="tabpanel">
                            <div class="mt-3 ml-3">
                                <p>Gegevens om te communiceren met Podio. Deze gegevens kunnen teruggevonden worden
                                    onder de Accountinstellingen van podio (<a href="https://podio.com/settings/api"
                                                                               target="_blank">https://podio.com/settings/api</a>).
                                    Het volstaat om deze te kopieren en hieronder in te vullen.
                                </p>
                            </div>
                            <div class="form-group row mt-4 ml-1">
                                <label class="col-sm-3 col-form-label" for="podio_client_id"><b>Client ID</b></label>
                                <div class="col-sm-6">
                                    <input class="form-control" id="podio_client_id" placeholder="e.g. am-ild7dj"
                                           type="text" v-model="podio_client_id">
                                </div>
                                <div class="col-sm-3">
                                    <button @click="submitPodio('podio_client_id',podio_client_id)"
                                            class="btn btn-primary"
                                            type="button">Opslaan
                                    </button>
                                </div>
                            </div>
                            <div class="form-group row ml-1">
                                <label class="col-sm-3 col-form-label" for="podio_client_secret"><b>Geheime Code
                                    Client</b></label>
                                <div class="col-sm-6">
                                    <input class="form-control" id="podio_client_secret"
                                           placeholder="e.g. jhxCLVT8w54dkRCdGvzZKwOXga2u6bxM2NwutQhqhuBoyQSKbsXWBRLLhnWOnnHg"
                                           type="text" v-model="podio_client_secret">
                                </div>
                                <div class="col-sm-3">
                                    <button @click="submitPodio('podio_client_secret',podio_client_secret)"
                                            class="btn btn-primary"
                                            type="button">Opslaan
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import customColorPicker from '@/components/custom-color-picker.vue'
    import {mapGetters} from 'vuex'

    export default {
        name: 'settings',
        data() {
            return {
                background: {title: 'Achtergrond', attribute: 'background_color'},
                primary: {title: 'Hoofdkleur', attribute: 'primary_color'},
                secondary: {title: 'Accentkleur', attribute: 'secondary_color'},
                background_color: null,
                primary_color: null,
                secondary_color: null,
                file: null,
                podio_client_id: null,
                podio_client_secret: null,
            };
        },
        computed: mapGetters({
                settings: 'SETTINGS'
            }
        ),
        components: {
            customColorPicker
        },
        mounted() {
            this.podio_client_id = this.settings.podio_client_id
            this.podio_client_secret = this.settings.podio_client_secret
            this.background_color = this.settings[this.background.attribute]
            this.primary_color = this.settings[this.primary.attribute]
            this.secondary_color = this.settings[this.secondary.attribute]
        },
        methods: {
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
            },
            changeValue(dataObject) {
                this[dataObject.attribute] = dataObject.color
            },
            submit() {
                //Moet in array voor backend
                let formData = new FormData();
                formData.append('value', this.file)
                this.$store.dispatch('UPDATE_SETTING_OPTION', {option: 'file', formData})
                    .then(() => {

                    })
                    .catch((error) => {
                    })
            },
            submitColors() {
                //Moet in array voor backend
                let formData = new FormData();
                formData.append('value', this.file)
                let settings = [
                    {
                        option: this.background.attribute,
                        value: this.background_color
                    },
                    {
                        option: this.primary.attribute,
                        value: this.primary_color
                    },
                    {
                        option: this.secondary.attribute,
                        value: this.secondary_color
                    }
                ]
                this.$store.dispatch('UPDATE_SETTING_MULTIPLE', {settings})
                    .then(() => {

                    })
                    .catch((error) => {
                    })
            },
            submitPodio(option, value) {
                this.$store.dispatch('UPDATE_SETTING_OPTION', {option: option, value: value})
                    .then(() => {

                    })
                    .catch((error) => {
                    })
            },
        }
    }
</script>
<style>
    .control-label, .label {
        font-weight: 500;
    }

    .nav-link.active {
        background-color: #6c757d !important;
        color: white !important;
    }

    .nav-link {
        color: #6c757d !important;
    }
</style>
